import { IProductData } from '../services/device.service';
import { AutocompleteFieldsConstants } from '../../ui/constants/autocomplete-fields.constants';
import { IProduct } from '../../shared/models/product.model';
import {
  IAdditionalComponentsCatalogueCart,
  IProductAccessories,
  IUpdateBomAccessory
} from '../models/product-accessories.model';
import { IBomModel } from '../../prisma-xs/models/bom.model';

export const generateDataForCustomProduct = (
  customProduct: IProductData | IProduct,
  enclosureId: number,
  projectId: number,
  descriptionField: string) => {
  return {
    enclosureId: enclosureId ? enclosureId : undefined,
    projectId,
    reference: customProduct.reference?.toUpperCase(),
    enumber: customProduct.enumber,
    description: customProduct[descriptionField],
    quantity: customProduct.quantity ? customProduct.quantity : 1,
    price: customProduct.price,
    deliverToCustomer: customProduct.deliverToCustomer,
    deliverToPanelBuilder: customProduct.deliverToPanelBuilder
  };
};

export const findArticle = (field: string, products: IProduct[], reference: string, enumber: string) => {
  const searchArticle = (field === AutocompleteFieldsConstants.REFERENCE) ? reference : enumber;
  return products.find(item => item[field].toString() === searchArticle?.toUpperCase());
};

export const mapProductsFromAccessoriesCartToBomModelsAndProductAccessories = (productsFromCart: IAdditionalComponentsCatalogueCart[],
                                                                               bomModelsAccessories: IBomModel[],
                                                                               enclosureId: number,
                                                                               // eslint-disable-next-line max-len
                                                                               projectId: number): IProductAccessories[] => {
  const newBomAccessories: IProductAccessories[] = [];

  productsFromCart.forEach(item => {
    newBomAccessories.push(generateProductAccessory(item, enclosureId, projectId))
  });

  return newBomAccessories;
}

const generateProductAccessory = (additionalComponentCatalogueProduct: IAdditionalComponentsCatalogueCart,
                                  enclosureId: number,
                                  projectId: number) : IProductAccessories => {
  return {
    projectId,
    description: additionalComponentCatalogueProduct?.product?.pDescription,
    reference: additionalComponentCatalogueProduct?.product?.reference,
    price: additionalComponentCatalogueProduct?.product?.price,
    quantity: additionalComponentCatalogueProduct?.quantity,
    enclosureId: enclosureId?? undefined,
    enumber: additionalComponentCatalogueProduct?.product?.enumber?.toString(),
    deliverToPanelBuilder: additionalComponentCatalogueProduct?.product?.deliverToPanelBuilder,
    deliverToCustomer: additionalComponentCatalogueProduct?.product?.deliverToCustomer
  }
}

export const mapToUpdateBomAccessoryFormat = (items: IBomModel[]): IUpdateBomAccessory[] => {
  return items.map(bomModelItem => {
    return {
      quantity: bomModelItem?.quantity,
      additionalBomEntryId: bomModelItem?.article?.id
    }
  })
}
